export function isHandheldLikeNow(): boolean {
  if (typeof window === 'undefined' || !window.matchMedia) return false

  const mm = window.matchMedia.bind(window)

  const hasFinePointer = mm('(pointer: fine)').matches || mm('(any-pointer: fine)').matches
  const hasHover = mm('(hover: hover)').matches || mm('(any-hover: hover)').matches
  const canTouch = (navigator.maxTouchPoints ?? 0) > 0
  const anyCoarse = mm('(any-pointer: coarse)').matches
  const uaMobile =
    (navigator as any).userAgentData?.mobile ??
    /Android|iPhone|iPad|iPod|Windows Phone/i.test(navigator.userAgent)
  const isPWA =
    mm('(display-mode: standalone)').matches ||
    mm('(display-mode: fullscreen)').matches ||
    mm('(display-mode: minimal-ui)').matches

  if (uaMobile) return true

  if (hasFinePointer || hasHover) return false

  if (canTouch && anyCoarse) return true

  return isPWA
}
